<script>
  import { getContext } from 'svelte'

  import { scaleLinear } from 'd3-scale'
  import { formatDateAxis, formatThousands } from '../functions.js'
  import { draggable } from 'svelte-drag'
  export let type = 'y'
  export let scale = { x: null, y: null }
  export let height, width
  let dragScale
  let { margin } = getContext('chart')
  margin.right = 50
  let startX
  let startX2
  export let data
  export let values
  let radius = 4
  let hoverNumber = 0
  let hoverDate = ''
  let hoverNumber2 = 0
  let hoverDate2 = ''
  let hoverDiff = 0
  $: hoverDiff = ((hoverNumber2 - hoverNumber) / hoverNumber) * 100
  let x = 100
  let y = 0
  let x2 = 200
  let y2 = 0
  let startDate1 = '2020-11-07'
  let startDate2 = '2021-03-28'

  $: dragScale = scaleLinear()
    .range([0, data.length])
    .domain([0, width - margin.right - margin.left + 2])

  setTimeout(() => {
    x = data.filter((d) => d.refDate === startDate1)[0].id
    x2 = data.filter((d) => d.refDate === startDate2)[0].id

    initialPosition()
  }, 500)

  // markers
  let c1 = { x: -1000, y: 100 }
  let c2 = { x: -1000, y: 100 }

  setTimeout(() => {
    startX = margin.left
    startX2 = margin.left
    let startY = scale.y(data[startX][values.y])
    c1.x = scale.x(data[startX - margin.left][values.x])
    c1.y = startY
    c2.x = scale.x(data[startX - margin.left][values.x])
    c2.y = startY
  }, 100)

  function updatePosition(e) {
    c1.x = scale.x(data[Math.floor(dragScale(e.detail.offsetX))][values.x])
    c1.y = scale.y(data[Math.floor(dragScale(e.detail.offsetX))][values.y])
    hoverNumber = data[Math.floor(dragScale(e.detail.offsetX))][values.y]
    hoverDate = data[Math.floor(dragScale(e.detail.offsetX))][values.x]
  }
  function updatePosition2(e) {
    c2.x = scale.x(data[Math.floor(dragScale(e.detail.offsetX))][values.x])
    c2.y = scale.y(data[Math.floor(dragScale(e.detail.offsetX))][values.y])
    hoverNumber2 = data[Math.floor(dragScale(e.detail.offsetX))][values.y]
    hoverDate2 = data[Math.floor(dragScale(e.detail.offsetX))][values.x]
  }
  function initialPosition() {
    c1.x = scale.x(data[Math.floor(dragScale(x))][values.x])
    c1.y = scale.y(data[Math.floor(dragScale(x))][values.y])
    hoverNumber = data[Math.floor(dragScale(x))][values.y]
    hoverDate = data[Math.floor(dragScale(x))][values.x]

    c2.x = scale.x(data[Math.floor(dragScale(x2))][values.x])
    c2.y = scale.y(data[Math.floor(dragScale(x2))][values.y])
    hoverNumber2 = data[Math.floor(dragScale(x2))][values.y]
    hoverDate2 = data[Math.floor(dragScale(x2))][values.x]
  }

  function symbol() {
    if (hoverDiff < 0) {
      return ''
    } else if (hoverDiff > 0) {
      return '+'
    } else {
      return ''
    }
  }
</script>

{#if type === 'x'}
  {#each data as d}
    <rect
      class="hover x-hover"
      y="0"
      height={height - margin.bottom / 2}
      x={scale.x(d[values.x])}
      width="1"
    />
  {/each}
{/if}

<path
  class="hover-area"
  style="stroke: none; stroke-width: 0px;"
  d="M {c1.x} {c1.y - radius / 2} L {c2.x} {c2.y -
    radius / 2} L {c2.x} {height - margin.bottom} L {c1.x} {height -
    margin.bottom}"
/>

<line class="hover-line" x1={c1.x} x2={c2.x} y1={c1.y - 2} y2={c2.y - 2} />

<circle cx={c1.x} cy={c1.y - 2} r={radius} class="hover-circle" />
<circle cx={c2.x} cy={c2.y - 2} r={radius} class="hover-circle" />

<rect
  class="dragbar"
  width={width - margin.left - margin.right + 12}
  x={margin.left - 6}
  y={height - margin.bottom}
  height="30"
/>

<circle
  cx={startX}
  cy={height - margin.bottom}
  r="6"
  class="drag-circle"
  use:draggable={{
    bounds: '.dragbar',
    axis: 'x',
    position: { x, y },
  }}
  on:svelte-drag={(e) => updatePosition(e)}
/>

<circle
  cx={startX2}
  cy={height - margin.bottom}
  r="6"
  class="drag-circle"
  use:draggable={{
    bounds: '.dragbar',
    axis: 'x',
    position: { x: x2, y: y2 },
  }}
  on:svelte-drag={(e) => updatePosition2(e)}
/>

<text class="hover-number" x={c1.x - 10} y={c1.y - 7}
  >{formatThousands(hoverNumber)}</text
>
<text class="hover-date" x={c1.x - 10} y={c1.y + 7}
  >{formatDateAxis(hoverDate)}</text
>

<!-- End date labels -->

<text class="hover-number hover-right" x={c2.x + 10} y={c2.y - 20}
  >{formatThousands(hoverNumber2)}</text
>
<text class="hover-date hover-right" x={c2.x + 10} y={c2.y - 5}
  >{formatDateAxis(hoverDate2)}</text
>

<text class="hover-change" x={c2.x + 10} y={c2.y - 37}
  >{symbol(hoverDiff)}{hoverDiff.toFixed(0)}%</text
>

<style>
  .dragbar {
    fill: none;
  }
  .hover-number {
    pointer-events: none;
    text-anchor: end;
    font-weight: 700;
  }
  .hover-date {
    pointer-events: none;
    text-anchor: end;
    font-weight: 500;
    font-size: 0.8rem;
  }
  .hover-change {
    font-size: 1.2rem;
    font-weight: 700;
    text-anchor: start;
  }
  .hover-circle {
    fill: red;
  }
  .hover-middle {
    text-anchor: middle;
  }
  .hover-right {
    text-anchor: start;
  }
</style>
